export default function() {
    return {
        surveys: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
        },
        detailedSurvey: {
            id: null,
            agencyObservations: null,
            agencyAnswerDate: null
        },
        showDetailedSurvey: false,
        replyText: null,
        search: {},
        fields: [
            {
                key: 'trip',
                label: 'Trip'
            },
            {
                key: 'answered',
                label: 'Respondido'
            },
            {
                key: 'actions',
                label: 'Responder'
            }
        ]
    }
}
